import * as React from 'react';

// Search/magnifier with the handle on the bottom-right (design-system "Search 2").
// Mirror of `SearchIcon`, which has its handle on the bottom-left.
const Search2 = ({ className, viewBox }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 10.6667 12.9039'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33333 9C7.35838 9 9 7.35838 9 5.33333C9 3.30829 7.35838 1.66667 5.33333 1.66667C3.30829 1.66667 1.66667 3.30829 1.66667 5.33333C1.66667 7.35838 3.30829 9 5.33333 9ZM5.33333 10.6667C8.27885 10.6667 10.6667 8.27885 10.6667 5.33333C10.6667 2.38781 8.27885 0 5.33333 0C2.38781 0 0 2.38781 0 5.33333C0 8.27885 2.38781 10.6667 5.33333 10.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41469 8.89681C7.89298 8.62067 8.50457 8.78454 8.78072 9.26284L10.0168 11.4038C10.2929 11.8821 10.1291 12.4937 9.65076 12.7698C9.17247 13.0459 8.56088 12.8821 8.28473 12.4038L7.04867 10.2628C6.77252 9.78454 6.9364 9.17295 7.41469 8.89681Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Search2;
